/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
 export default {


   sysManagement: { SC:"系统管理", TC: "系統管理" , EN: "Sytem" }
   ,update: { SC:"修改", TC: "修改", EN: "Edit" }
   ,delete: { SC:"删除", TC: "刪除", EN: "Delete" }
   ,audit: { SC:"日志", TC: "日誌", EN: "Log" }
   ,selectiveData: { SC:"请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
   ,deleteData: { SC:"数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
   ,deleteSuccess: { SC:"删除成功", TC: "刪除成功", EN: "Deleted successfully." }
   ,beQuerying: { SC:"查询中...", TC: "査詢中...", EN: "Searching..." }
   ,noneDate: { SC:"找不到符合条件记录.", TC: "找不到符合f條件記錄.", EN: "No record is founed." }
   ,saveSuccess: { SC:"保存成功", TC: "保存成功", EN: "Saved successfully." }
   ,controls: { SC:"操作", TC: "操作", EN: "Operation" }
   ,list: { SC:"列表", TC: "列表", EN: "List" }
   ,search: { SC:"查询", TC: "査詢", EN: "Search" }
   ,reset: { SC:"重置", TC: "重置", EN: "Reset" }
   ,add: { SC:"新增", TC: "新增", EN: "Add" }
   ,save: { SC:"保存", TC: "保存", EN: "Save" }
   ,cancel: { SC:"取消", TC: "取消", EN: "Cancel" }
   ,dataBeSaving: { SC:"数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }

   ,userId: { SC:"User ID", TC: "User ID", EN: "User ID" }
   ,userName: { SC:"用戶名", TC: "用戶名", EN: "User Name" }
   ,userNameIsNoNull: { SC:"用戶名不能为空", TC: "用戶名不能為空", EN: "User Name is required." }
   ,phone: { SC:"手机号码", TC: "手機號碼", EN: "Phone" }
   ,email: { SC:"邮箱", TC: "郵箱", EN: "Email" }
   ,activeInd: { SC:"状态", TC: "狀態", EN: "Status" }
   ,user: { SC:"用户", TC: "用戶", EN: "User" }
   ,newPwd: { SC:"新密码", TC: "新密碼", EN: "New Password" }
   ,newPwdIsNoNull: { SC:"新密码不能为空", TC: "新密碼不能為空", EN: "New Password is required." }
   ,passwordMin: { SC:"新密码最小长度为8位", TC: "新密碼最小長度為8位", EN: "The New Password has at least 8 digits." }
   ,updatePassword: { SC:"修改密码", TC: "修改密碼", EN: "Change Password" }
   ,userCode: { SC:"用户账号", TC: "用戶賬號", EN: "User Code" }
   ,userCodeIsNoNull: { SC:"用户账号不能为空", TC: "用戶賬號不能為空", EN: "User Code is required." }
   ,pwd: { SC:"确认密码", TC: "確認密碼", EN: "New Password(Comfirm)" }
   ,pwdIsNoNull: { SC:"确认密码不能为空", TC: "確認密碼不能為空", EN: "New Password(Comfirm) is required." }
   ,pwdInconformity: { SC:"确认密码和新密码不一致", TC: "確認密碼和新密碼不一致", EN: "The New Password is not consistent with the New Password(Comfirm)." }
   ,sysManage: { SC:"系统管理", TC: "系統管理" , EN: "System" }
  //  ,userCode: { SC:"用户账号", TC:"用戶賬號", EN: "User Code" }
}